module.exports = __webpack_public_path__ + "static/media/TF.55ecc12c.svg";